import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DialogComponent } from 'src/app/dialog.component';
import { sessionStorage } from 'src/app/localstorage.service';

@Component({
  selector: 'app-btl-approve-history-modal',
  templateUrl: './btl-approve-history-modal.component.html'
})
export class BtlApproveHistoryModalComponent implements OnInit {

  batches: any[] = [];
  loader: boolean = false;
  reversingBatchId: any = null;
  userId: any;
  userName: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<BtlApproveHistoryModalComponent>,
    public serve: DatabaseService,
    public toast: ToastrManager,
    public alert: DialogComponent,
    public session: sessionStorage
  ) {
    const userData = JSON.parse(localStorage.getItem('st_user'));
    this.userId = userData['data']['id'];
    this.userName = userData['data']['name'];
  }

  ngOnInit() {
    this.getBatchHistory();
  }

  getBatchHistory() {
    this.loader = true;
    this.serve.post_rqst({}, 'Event/getBtlApproveHistory').subscribe((result) => {
      this.loader = false;
      if (result['statusCode'] == 200) {
        this.batches = result['result'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }, err => {
      this.loader = false;
      this.toast.errorToastr('Something went wrong');
    });
  }

  confirmReverse(batch) {
    this.alert.delete('Reverse Batch ' + batch.batch_id + '?').then((result) => {
      if (result) {
        this.reverseBatch(batch.batch_id);
      }
    });
  }

  reverseBatch(batchId) {
    this.reversingBatchId = batchId;
    this.serve.post_rqst({
      batch_id: batchId,
      reversed_by_id: this.userId,
      reversed_by_name: this.userName
    }, 'Event/reverseBtlBatch').subscribe((result) => {
      this.reversingBatchId = null;
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg']);
        this.getBatchHistory();
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }, err => {
      this.reversingBatchId = null;
      this.toast.errorToastr('Something went wrong');
    });
  }
}
